import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import NPSCandidates from '../charts/NPSCandidates';
import NPSClients from '../charts/NPSClients';
import NPSCompanies from '../charts/NPSCompanies';
import {
  StyledCardTitle,
  StyledContainer,
  StyledHeader,
  StyledNps,
  StyledNpsChart,
  StyledNpsItem,
  StyledSatisfactionContent,
  StyledValueNumber
} from './SuccessRate.styled';

const Satisfaction: React.FC = () => {
  const { t } = useI18n('state-of-hiring');

  const npsData = [
    {
      value: '8.66',
      desc: t('state-of-hiring.success-rate.satisfaction.nps-clients'),
      chart: <NPSClients />
    },
    {
      value: '9.46',
      desc: t('state-of-hiring.success-rate.satisfaction.nps-candidates'),
      chart: <NPSCandidates />
    },
    {
      value: '7.92',
      desc: t('state-of-hiring.success-rate.satisfaction.nps-companies'),
      chart: <NPSCompanies />
    }
  ];

  return (
    <StyledContainer>
      <StyledSatisfactionContent>
        <div>
          <StyledHeader>
            <Heading2 editorial alignLeft>
              {t('state-of-hiring.success-rate.satisfaction.title')}
            </Heading2>
          </StyledHeader>
          <HtmlTrans
            i18nKey="state-of-hiring.success-rate.satisfaction.content"
            ns="state-of-hiring"
          />
        </div>
        <StyledNps>
          <StyledCardTitle>
            {t('state-of-hiring.success-rate.satisfaction.nps-title')}
          </StyledCardTitle>
          {npsData.map((item, index) => (
            <StyledNpsItem key={index}>
              <StyledNpsChart>
                {item.chart}
                <StyledValueNumber>{item.value}</StyledValueNumber>
              </StyledNpsChart>
              <span>{item.desc}</span>
            </StyledNpsItem>
          ))}
        </StyledNps>
      </StyledSatisfactionContent>
    </StyledContainer>
  );
};

export default Satisfaction;
